export default ({group, key, value = '' }) => {
    if (typeof group !== 'string') {
        throw new Error('group must be of type `string`');
    }

    if (typeof key !== 'string') {
        throw new Error('key must be of type `string`');
    }

    return { group, key, value };
};